import { render, staticRenderFns } from "./AdminPromotionsFeaturedEdit.vue?vue&type=template&id=3493ad00&"
import script from "./AdminPromotionsFeaturedEdit.vue?vue&type=script&lang=js&"
export * from "./AdminPromotionsFeaturedEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports